"use strict";
exports.__esModule = true;
var guestia_storage_1 = require("./guestia_storage");
var JWTStorage = /** @class */ (function () {
    function JWTStorage() {
        this.storage = new guestia_storage_1["default"]('localStorage', { jwt: { defaultValue: null } });
        this.state = this.storage.get('jwt') || null;
    }
    JWTStorage.prototype.get = function () {
        return this.state;
    };
    JWTStorage.prototype.set = function (jwt) {
        this.state = jwt;
        this.storage.set('jwt', jwt);
    };
    JWTStorage.prototype.remove = function () {
        this.state = null;
        this.storage.remove('jwt');
    };
    return JWTStorage;
}());
exports["default"] = JWTStorage;
